import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";

const Tag = forwardRef(({ onRemove, title, id }, ref) => {
  return (
    <div className={styles.tag} ref={ref}>
      {title}
      {onRemove && (
        <button
          className={styles.removeBtn}
          type="button"
          onClick={(e) => onRemove(id, e)}
        >
          <i className="icon icon-cross" />
        </button>
      )}
    </div>
  );
});

Tag.propTypes = {
  onRemove: PropTypes.func,
  title: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
Tag.defaultProps = {
  onRemove: null,
};
Tag.displayName = "Tag";

export default Tag;
